import React, { memo } from 'react'

import { SIGNUP_PROFILE_DISPATCH } from '../../../store/reducers/auth/signup'
import TermsPoliciesWrapper from 'wrappers/TermsPoliciesWrapper'
import CustomCheckbox from '../inputs/CustomCheckbox'

const TermsCheckbox = ({
  dispatchAction,
  signupProfile: { error, termsAccepted },
  t
}) => {
  return (
    <CustomCheckbox
      label={
        <TermsPoliciesWrapper
          t={t}
          i18nKey='brand:common.i-hereby-accept-terms-policy'
        />
      }
      checked={termsAccepted}
      onChange={() =>
        dispatchAction(SIGNUP_PROFILE_DISPATCH.TERMS_ACCEPTED, !termsAccepted)
      }
      error={error[SIGNUP_PROFILE_DISPATCH.TERMS_ACCEPTED]}
    />
  )
}

export default memo(TermsCheckbox)
